import React from "react";
import { FaCheck } from "react-icons/fa";
import { useState } from "react";
import { width } from "@mui/system";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, profileImage } from "../../redux/counterSlice";
import { useOutletContext } from "react-router-dom";
import { CircularProgress } from "@mui/material";
export default () => {
  const dispatch = useDispatch();
  const { profile_url, setProfile_url } = useOutletContext();
  let initialState = {
    driver_license_url: "",
    email: "",
    first_name: "",
    last_name: "",
    // password: "",
    usdot_number: "",
    address: "",
    phone_number: "",
  };
  const state = useSelector((state) => state.auth);
  const { userId } = state;
  const [owner, setOwner] = useState(initialState);
  const [showPassword, setShowPassword] = useState(true);
  const [Loading, setloading]=useState(false)
  const [driverLicense, setDriverLicense] = useState("");
  const handleChange = (key, value) => {
    setOwner({ ...owner, [key]: value });
    if (key === "driver_license_url") {
      setDriverLicense(URL.createObjectURL(value));
    }
  };
  const { request, loading, error } = useApi((formdata) =>
  
    apiClient.patch(`/authentication/accounts/${userId}/`, formdata)
  );
  useEffect(() => {
    const fetch = async () => {
      const response = await apiClient.get(
        `/authentication/accounts/${userId}/`
      );
      const data = response.data;
      setProfile_url(response?.data?.profile_url);
      setOwner(data);
      dispatch(
        login({
          ...state,
          name: data?.first_name,
        })
      );
    };
    fetch();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setloading(true);
    const formdata = new FormData();
    formdata.append("user_id", userId);
    if (owner?.driver_license_url instanceof File) {
      formdata.append("driver_license_url", owner?.driver_license_url);
    }
    if (profile_url instanceof File) {
      formdata.append("profile_url", profile_url);
    }
    formdata.append("email", owner?.email);
    formdata.append("first_name", owner?.first_name);
    formdata.append("last_name", owner?.last_name);
    // formdata.append("password", owner?.password);
    formdata.append("usdot_number", owner?.usdot_number);
    formdata.append("address", owner?.address);
    formdata.append("phone_number", owner?.phone_number);
    ;
    const result = await request(formdata);
    if (!result.ok) {
      setloading(false)
      return toast.error("Error");
     
    } else {
      setloading(false)
      return toast.success("Account info Successfully Update");
     
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <div className="input-fields ">
                <div className=" row gap-1 gap-md-2 justify-content-between">
               <div className="input-field col-md-5 d-flex flex-column mb-1 fs-5">
  <label className="label blue-clr m-1" htmlFor="liscense">
    Driver's License
  </label>
  <label
    className="form-control licence_bg m-1 px-2 py-1  fs-4 file-input text-center"
    htmlFor="liscense"
  >  {
    owner?.driver_license_url?
    <div className="file-uploaded-text " style={{padding:"6px 0px"}}>File uploaded</div>:
    <i className="bi p-0 bi-image-fill"  />
    } 
    <input
      hidden
      type="file"
      className="form-control m-1 px-2 py-1 fs-4"
      id="liscense"
      onChange={(e) =>
        handleChange("driver_license_url", e.target.files[0])
      }
    />
  </label>
</div>


                  <div className=" input-field col-md-5 d-flex flex-column mb-1 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Email">
                      Email
                    </label>
                    <input 
                        
                      type="email"
                      value={owner?.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Email"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="First-name">
                      First Name
                    </label>
                    <input
                      type="text"
                    
                      value={owner?.first_name}
                      onChange={(e) =>
                        handleChange("first_name", e.target.value)
                      }
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="First-name"
                    />
                  </div>

                  {/* <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Password">
                      Password
                    </label>
                    <div className="position-relative d-flex align-items-center">
                      <input
                       
                        type={showPassword ? "password" : "text"}
                        className="form-control m-1  px-2 py-1 pe-5 fs-4"
                        id="Password"
                        value={owner?.password}
                        onChange={(e) =>
                          handleChange("password", e.target.value)
                        }
                      />
                      <span
                        className="show-password"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i class="bi bi-eye-fill"></i>
                        ) : (
                          <i class="bi bi-eye-slash-fill"></i>
                        )}
                      </span>
                    </div>
                  </div> */}
                       <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="usdot_number"
                    >
                      USDOT Number
                    </label>
                    <input
                      type="number"
                      
                      value={owner?.usdot_number}
                      onChange={(e) =>
                        handleChange("usdot_number", e.target.value)
                      }
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="usdot_number"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Last-name">
                      Last Name
                    </label>
                    <input
                     
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Last-name"
                      value={owner?.last_name}
                      onChange={(e) =>
                        handleChange("last_name", e.target.value)
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="Phone-Number"
                    >
                      Phone Number
                    </label>
                    <input
                     
                      type="number"
                      value={owner?.phone_number}
                      onChange={(e) =>
                        handleChange("phone_number", e.target.value)
                      }
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Phone-Number"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-center">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5 ">
                    <label className="label blue-clr m-1" htmlFor="address">
                      Address
                    </label>
                    <input
                     
                      type="text"
                      value={owner?.address}
                      onChange={(e) =>
                        handleChange("address", e.target.value)
                      }
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="address"
                    />
                  </div>
                
                </div>
              </div>
              <div className="select-applies d-flex flex-column align-items-center justify-content-center">
               {!Loading? <button
                  type="submit"
                  className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                >
                  <span className="pe-2">Save Changes</span>
                  <FaCheck />
                </button>: <div className="text-center mt-3">
            <h1>       <CircularProgress /></h1>
          </div>}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
